import { createFileRoute } from "@tanstack/react-router";

// Danh sách đơn chờ hậu kiểm ảnh gốc (QĐ 0521).
export const Route = createFileRoute("/_app/qc-desk/hau-kiem")({});
